'use strict';

var getOwnKey = require('../../common/internal/getOwnKey');

function getDateParamKey(params, key) {
  return getOwnKey(params, key) ||
         getOwnKey(params, key + 's') ||
         (key === 'day' && getOwnKey(params, 'date'));
}

module.exports = getDateParamKey;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/getDateParamKey.js
// module id = 275
// module chunks = 0